import type { LexicalEditor, LexicalNode } from "lexical";
import { $isElementNode } from "lexical";

export function $exportHtml(editor: LexicalEditor, node: LexicalNode): string {
  const container = document.createElement("div");
  $appendNodesToHTML(editor, node, container);

  return container.innerHTML;
}

function $appendNodesToHTML(
  editor: LexicalEditor,
  currentNode: LexicalNode,
  parentElement: HTMLElement | DocumentFragment,
): boolean {
  const shouldExclude = $isElementNode(currentNode) && currentNode.excludeFromCopy("html");
  const children = $isElementNode(currentNode) ? currentNode.getChildren() : [];

  const { element, after } = currentNode.exportDOM(editor);

  if (!element || !("append" in element)) return false;

  const fragment = document.createDocumentFragment();

  children.forEach((childNode) => $appendNodesToHTML(editor, childNode, fragment));

  if (!shouldExclude) {
    // @ts-expect-error we don't know if this is client or server code either
    element.append(fragment);
    // @ts-expect-error we don't know if this is client or server code either
    parentElement.append(element);

    if (after) {
      const newElement = after.call(currentNode, element);
      if (!("replaceWith" in element)) return false;
      if (newElement) element.replaceWith(newElement);
    }
  } else {
    // @ts-expect-error we don't know if this is client or server code either
    parentElement.append(fragment);
  }

  return true;
}
